import { useContext, useState, useEffect } from 'react'
import { MarkupContext } from '../../providers/Markup'
import { ArrowUpCircleIcon } from '@heroicons/react/24/solid'
import ButtonEl from '../helpers/ctas/Button'

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // for smoothly scrolling
  })
}

const BackToTop = (props) => {
  const { detectPaletteClass } = useContext(MarkupContext)
  const [showButton, setShowButton] = useState(false)

  const textClassName = 'text-(--sb-back--top)'; 
  
  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        setShowButton(true)
      } else {
        setShowButton(false)
      }
    })
  }, [])

  return (
    <ButtonEl
      theme="text"
      buttonType="none"
      showDecorator={false}
      onClick={scrollToTop}
      className={`fixed p-0! shadow-2xl! bottom-20 right-0 md:bottom-10 md:right-10 z-1 hover:scale-[1.1] ${showButton ? 'opacity-100' : 'opacity-0'}`}
    >
      <div className="rounded-full bg-white text-shadow-off shadow-2xl">
        <ArrowUpCircleIcon
          role="none"
          className={detectPaletteClass(`w-12 h-12 ${textClassName}`)}
        />
        <span className="sr-only">Back to top</span>
      </div>
    </ButtonEl>
  )
}

export default BackToTop
